<template>
    <div id="page">
        <div class="content">
            <div class="info-container">
                <label>{{ $t('settings.info') }}</label>
            </div>
            <div class="input-container">
<!--                 <label type="text">{{ $t('settings.client') + ': ' + cookie.client }}</label>
                
                <label type="text">{{ $t('settings.option') + ': ' + cookie.profile }}</label> -->
                
                <button @click="setCookie" type="button">{{ $t('settings.set-cookie') }}</button>
            </div>
        </div>
        <div class="result" v-if="result" >
            <label>{{ $t('settings.success') }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CookieSetterPage',
    data() {
        return {
            cookie: {
                client: null,
                profile: null
            },
            result: false
        }
    },
    mounted() {
        this.cookie = this._getCookie()
        console.log(this.cookie)
    },
    methods: {
        setCookie: function() {
            const content = {
                client: process.env.VUE_APP_CLIENT,
                profile: process.env.VUE_APP_PROFILE_NAME
            }

            this._setCookie(content)
            this.cookie = this._getCookie()
            this.result = true
        }
    }
}
</script>

<style scoped>
#page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

input,
button,
label {
    display: block;
}

.content {
    margin: 0 auto;
    width: 100%;
}

@media(min-width: 501px) {
    .content {
        width: 50%;
        min-width: 500px;
    }
}

.info-container {
    font-size: 1.2em;
}

.input-container {
    margin: 0 auto;
}

.input-container > button {
    background: #0069B4;
    color: #fff;
    margin: 0 auto;
    margin-top: 25px;
}

.input-container > button:hover {
    background: #0069B499;
}

.input-container > label {
    margin: 0 auto;
    margin-top: 10px;
}
.input-container > input {
    margin: 0 auto;
    margin-top: 0px;
}

.result {
    margin-top: 20px;
}

.result > label {
    margin-top: 5px;
}

.result > label:nth-of-type(1) {
    color: green;
    margin-bottom: 20px;
}
</style>